module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Question-circle-7975952bf04a077dd7376a205201eae4.svg";